
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/pdf-to-indesign",
      function () {
        return require("private-next-pages/converter/pdf-to-indesign.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/pdf-to-indesign"])
      });
    }
  